import { Translate } from "features/cabinet-tasks/task-row";

/** The name of the month of a period (YYYY-MM) the way it reads before «ataskaitą»: "rugsėjo". */
export function fuelMonthName(period: string, t: Translate): string {
  return t(`cabinet_fuel_month_${period.slice(5, 7)}`);
}

/** The month a missing-report task is for: its link ends in ?period=2026-09&asset=<id>. */
export function fuelTaskPeriod(link: string): string {
  return new URLSearchParams(link.split("?")[1]).get("period") ?? "";
}
